// src/user-settings/types.ts
var DEFAULT_USER_SETTINGS = {
  watch: { standaloneMode: false }
};

export { DEFAULT_USER_SETTINGS };
//# sourceMappingURL=chunk-UJBTIEC5.mjs.map
//# sourceMappingURL=chunk-UJBTIEC5.mjs.map